import { InferredProgressValue } from 'api/project';
import { KeyCreatorFunction } from './types';

export const inferredProgressKeyCreator: KeyCreatorFunction<
  InferredProgressValue | undefined
> = ({ value }) => {
  return value ?? InferredProgressValue.None;
};
